import { api, queryKeys, type User } from '@alpha/api-client';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { DataTable } from '../../components/DataTable';
import { PageHeader } from '../../components/PageHeader';
import { useTableQuery } from '../../hooks/useTableQuery';
import { useSession } from '../../hooks/useSession';
import { Card, Input } from '../../ui';
import { TEAM_TABS, teamColumns } from './DirectTeam';

export function ReferralList() {
  const { query, setPage } = useTableQuery();
  const { user } = useSession();

  const referralLink = user
    ? `${window.location.origin}/register?ref=${user.user_code}`
    : '';

  const { data, isLoading, error } = useQuery({
    queryKey: queryKeys.team('referral-list', query),
    queryFn: () => api.team.referralList(query),
  });

  const columns = useMemo(() => teamColumns, []);

  return (
    <>
      <PageHeader title="Referral List" tabs={TEAM_TABS} />

      <Card>
        <h3 className="card-title">Your referral link</h3>
        <Input
          readOnly
          value={referralLink}
          onFocus={(e) => e.currentTarget.select()}
        />
      </Card>

      <DataTable<User>
        title="Referrals"
        columns={columns}
        data={data?.data}
        meta={data?.meta}
        isLoading={isLoading}
        error={error as Error | null}
        onPageChange={setPage}
      />
    </>
  );
}
